import styled from '@emotion/styled'

const Layout = styled.section``

Layout.Header = styled.header`
  display: flex;
  background-color: #c1d1da;
  height: 70px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: #0c0c0c;
`

Layout.Navigation = styled.nav`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.Link = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
  color: #0c0c0c;
`

Layout.Hero = styled.div`
  background: url(${({ backgroundImage }) => backgroundImage});
  background-position: center;
  background-size: cover;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    background: #002D3640;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: calc(100vh + 70px);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleContainer = styled.div`
  display: flex;
  width: 100%;
  margin: auto 0;
  justify-content: center;
`

Layout.Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  color: #ffffff;
  align-self: center;
  margin-top: 1em;
`

export default Layout
